module.exports = __webpack_public_path__ + "d50d949431af316d2131548d9bf194bc.pdf";